import { render, staticRenderFns } from "./IncidentsTypesReport.vue?vue&type=template&id=54e32aac&scoped=true"
import script from "./IncidentsTypesReport.vue?vue&type=script&lang=js"
export * from "./IncidentsTypesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e32aac",
  null
  
)

export default component.exports